import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { LayoutConfigService, ToggleOptions } from '@app/core/_base/layout';
import { ScanLocationComponent } from '@app/shared/components/scan-location/scan-location.component';

@Component({
  selector: 'kt-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrls: ['./header-mobile.component.scss'],
})
export class HeaderMobileComponent implements OnInit {
  headerLogo :string = 'assets/logo/svg/luminous-horiz-rgb-fullcolor.svg';
  asideDisplay :boolean;

  toggleOptions :ToggleOptions = {
    target: 'body',
    targetState: 'kt-header__topbar--mobile-on',
    togglerState: 'kt-header-mobile__toolbar-topbar-toggler--active',
  };

  constructor(
    private layoutConfigService :LayoutConfigService,
    private router :Router,
    private modalSvc :NgbModal,
  ) {}

  ngOnInit() {
    this.asideDisplay = this.layoutConfigService.getConfig('aside.self.display');
  }

  toScan() {
    this.router.navigate(['/tools/scan']);
  }

  scanLocation() {
    const modalRef = this.modalSvc.open(ScanLocationComponent, {});

    modalRef.result.then(
      (locationId) => {
        this.router.navigate([`/locations/s/${locationId}/details`]);
      },
      () => {},
    );
  }
}
